import React from 'react';
import styled from 'styled-components';
import { toast as toastifyToast } from 'react-toastify';
import {
  AlertCircleIcon,
  CheckCircleIcon,
  InfoCircleIcon,
  WarnCircleIcon,
} from 'base/components/Icon';

const ToastContent = styled.div`
  position: relative;
  padding-left: 35px;
  .icon {
    position: absolute;
    left: 0;
    top: 0;
  }
`;

const Toast = ({ children, icon }) => {
  const Icon = icon;
  return (
    <ToastContent>
      <Icon size="25px" inlineLeft className="icon" />
      {children}
    </ToastContent>
  );
};

const toast = {};

toast.info = (content, options) =>
  toastifyToast.info(<Toast icon={InfoCircleIcon}>{content}</Toast>, options);

toast.success = (content, options) =>
  toastifyToast.success(<Toast icon={CheckCircleIcon}>{content}</Toast>, options);

toast.warn = (content, options) =>
  toastifyToast.warn(<Toast icon={WarnCircleIcon}>{content}</Toast>, options);

toast.error = (content, options) =>
  toastifyToast.error(<Toast icon={AlertCircleIcon}>{content}</Toast>, options);

export default toast;
